// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wYHg5F5md2zzvMyOoKAt {
  padding: 0 20px 0;
  display: flex;
  align-items: center;
}
.wYHg5F5md2zzvMyOoKAt .field-body {
  flex: none;
  max-width: inherit;
}
.wYHg5F5md2zzvMyOoKAt .CmP2bMDLnG3qLePwC2L7 {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/pages/admin/project/wordTable/list/WordTable.module.scss"],"names":[],"mappings":"AAAA;EAEE,iBAAA;EACA,aAAA;EACA,mBAAA;AAAF;AAEE;EACE,UAAA;EACA,kBAAA;AAAJ;AAEE;EACE,gBAAA;AAAJ","sourceRoot":""}]);
// Exports
export var header = `wYHg5F5md2zzvMyOoKAt`;
export var selectorOption = `CmP2bMDLnG3qLePwC2L7`;
export default ___CSS_LOADER_EXPORT___;
